import { motion, useInView, animate } from "framer-motion";
import { useRef, useEffect, useState } from "react";

function Counter({ target, suffix = "" }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!isInView) return;
    const num = parseInt(target);
    const controls = animate(0, num, {
      duration: 2,
      ease: "easeOut",
      onUpdate(value) {
        setDisplay(Math.round(value).toString());
      },
    });
    return controls.stop;
  }, [isInView, target]);

  return (
    <span ref={ref}>
      {display}
      {suffix}
    </span>
  );
}

const stats = [
  { value: "100", suffix: "+", label: "Abgeschlossene Projekte" },
  { value: "10", suffix: "+", label: "Jahre im Geschäft" },
  { value: "100", suffix: "%", label: "Pünktliche Fertigstellungen" },
];

export default function ProjectsCompleted() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
        {stats.map((stat, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.15 }}
          >
            <p className="text-darkBlue text-5xl md:text-6xl font-bold">
              <Counter target={stat.value} suffix={stat.suffix} />
            </p>
            <p className="text-gray-600 mt-2">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
